module.exports = __webpack_public_path__ + "img/file-icon-active.c3bfe99f.svg";